import { action, observable } from "mobx";
import Autobind from "autobind-decorator";
import Helper from "helper";
import Exception from "core/except";

@Autobind
class HotkeyModel {
  @observable
  _name: string = "";
  @observable
  _description: string = "";
  @observable
  _sequence: string[] | string;
  @observable
  _actionType: string = "keydown";

  constructor(
    name: string,
    description: string,
    sequence: string[] | string,
    action: string
  ) {
    Exception.assert(
      ["keydown", "keyup", "keypress"].indexOf(action) !== -1,
      "Invalid argument for Hotkeymodel",
      Exception.InvalidArgumentException
    );
    this._name = name;
    this._description = description;
    this._sequence = sequence;
    this._actionType = action;
  }

  @action
  setHotkeyModel(
    name: string,
    description: string,
    sequence: string[] | string,
    actionType: string
  ) {
    Exception.assert(actionType in ["keydown", "keyup", "keypress"]);
    this._name = name;
    this._description = description;
    this._sequence = sequence;
    this._actionType = actionType;
  }

  set name(name: string) {
    this._name = name;
  }
  get name(): string {
    return this._name;
  }

  set description(description: string) {
    this._description = description;
  }
  get description(): string {
    return this._description;
  }

  set sequence(sequence: string[] | string) {
    if (Helper.Validator.isArray(sequence) === true) {
      this._sequence = sequence.slice();
    } else if (Helper.Validator.isString(sequence as string) === true) {
      this._sequence = sequence;
    } else {
      //throw
    }
  }
  get sequence(): string[] | string {
    return this._sequence;
  }

  set action(actionType: string) {
    this._actionType = actionType;
  }
  get action() {
    return this._actionType;
  }
}

export default HotkeyModel;
